import type { FaireProductEntity } from "../../entity_types/product";

export const p_2zfbdpzks7: FaireProductEntity = {
  token: "p_2zfbdpzks7",
  type: "product",
  name: "fluted bouquet gift tags",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/c92bc3dbc376915c84e8f88587f138e339124c9e7e0cff7fe537a1863d586bd3.jpeg",
  galleryImageUrls: [],
  priceDollars: 6,
  description:
    'Add a finishing touch to your wrapped gifts with a cheerful gift tag. Blank on reverse for space for a note or name.\n\nDetails:\n- Set of eight tags\n- 2" x 3.5"\n- String included\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:15:07.446Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
